const routerArr = [
  {
    path: '/faceauthsuccess',
    name: 'faceauthsuccess',
    meta: { title:'人脸识别成功' ,login:true},
    component: () => import(/* webpackChunkName: 'supervise' */ './page/faceauthsuccess.vue'),
  },
  {
      path: '/faceauthfail',
      name: 'faceauthfail',
      meta: { title:'人脸识别失败' ,login:true},
      component: () => import(/* webpackChunkName: 'supervise' */ './page/faceauthfail.vue'),
  },
  {
    path: '/privacypolicy',
    name: 'privacypolicy',
    meta: { title:'隐私政策',login:true },
    component: () => import(/* webpackChunkName: 'supervise' */ './page/privacypolicy.vue'),
  },
  {
    path: '/faceidentify',
    name: 'faceidentify',
    meta: { title:'人脸识别' ,login:true},
    component: () => import(/* webpackChunkName: 'supervise' */ './page/faceidentify.vue'),
  },
]
export default routerArr